import './inbox_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

String::endsWith = (s) ->
  this[this.length-s.length...] == s

class Monitoring.Models.SocialContents.ClippingContent extends Monitoring.Models.SocialContents.InboxContent

  hasUser: ->
    @isClippingComment()

  enhancedContent: (name, evidenceName, avoidAnchorsReplacement=false, trim=false) ->
    return '' unless @getValue(name)
    new Monitoring.Models.ContentEnhancer(this, @getValue(name)).getContent
      evidenceField: evidenceName
      addAnchors: !avoidAnchorsReplacement
      trim: trim

  enhancedNewsBody: ->
    @enhancedContent('body', 'body', false, true)
